import React, { useEffect, useState } from "react";
import BookingServices from "../../../services/axiosServices/apiServices/BookingServices";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { checkParameters } from "../../../utils/Encryption";
import SwalServices from "../../../services/swalServices/SwalServices";
import { APIURL } from "../../../services/axiosServices/ApiEndPoints";
import AcceptBookingCancellation from "./AcceptBookingCancellation";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";

const LNewBookingCancellationDetail = () => {
    const bookingServices = new BookingServices();
    const swalServices = new SwalServices();
    const Navigate = useNavigate()

    const [bookingCancellationDetails, setBookingCancellationDetails] = useState({
        cancellationId: null,
        className: "",
        classDate: "",
        eventFormStartDate: "",
        eventFormEndDate: "",
        availableSessions: "",
        reason: "",
        medicalCertificateName: "",
        medicalCertificate: "",
        bookingReferenceNo: "",
        bookingStatus: "",
        attendeeName: "",
        contactNo: "",
        bookingDate: "",
        paymentVia: "",
        promoCode: "",
        subTotalPrice: "",
        discountPrice: "",
        totalPrice: "",
        location: "",
        eventStartTime: "",
        eventEndTime: "",
        BookingCancalltionStatusId: null,
        bookingStatusId:null,

        
    });

    const [route, setRoute] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [IsRejected, setIsRejected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const getBookingCancellationDetailsById = (id) => {
        setIsLoading(true);
        bookingServices.getBookingCancellationDetailsById(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                // response?.responseItem?.responseContent?.bookingDate = moment(response.responseItem.responseContent.bookingDate).format("DD MMM YYYY");
                // response?.responseItem?.responseContent?.classDate = moment(response.responseItem.responseContent.classDate).format("DD MMM YYYY");
                const details = response?.responseItem?.responseContent;
                setBookingCancellationDetails(details);
            } else {
                swalServices.Error(response?.message);
            }
            setIsLoading(false);
        });
    };

    useEffect(() => {
        let params = new URLSearchParams(window.location.search);
        let CancellationId = params.get("");
        if (CancellationId && (CancellationId = checkParameters(CancellationId, "Number"))) {
            if (CancellationId != null && CancellationId > 0) {
                getBookingCancellationDetailsById(CancellationId);
            }
        }
    }, []);

    const approveBookingRequestForCancellation = () => {
        setModalOpen(true);
    };

    const rejectBookingRequestForCancellation = () => {
        let req = {};
        setIsRejected(true);
        req.cancellationId = bookingCancellationDetails?.cancellationId
            ? bookingCancellationDetails?.cancellationId
            : null;
        req.bookingReferenceNo = bookingCancellationDetails?.bookingReferenceNo
            ? bookingCancellationDetails?.bookingReferenceNo
            : "";
        req.eventName = bookingCancellationDetails?.eventName
            ? bookingCancellationDetails?.eventName
            : "";
        req.bookingStatus = bookingCancellationDetails?.bookingStatus
            ? bookingCancellationDetails?.bookingStatus
            : "";
        req.eventTypeName = bookingCancellationDetails?.eventTypeName
            ? bookingCancellationDetails?.eventTypeName
            : "";
        req.attendeeName = bookingCancellationDetails?.attendeeName
            ? bookingCancellationDetails?.attendeeName
            : "";
        req.attendeeEmail = bookingCancellationDetails?.attendeeEmail
            ? bookingCancellationDetails?.attendeeEmail
            : "";
        req.requestDate = bookingCancellationDetails?.requestDate
            ? bookingCancellationDetails?.requestDate
            : null;
        bookingServices.rejectBookingRequestForCancellation(req).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                swalServices.Success("Cancellation Booking Application has been rejected");
                Navigate("/booking/BookingCancellation");
                
            } else {
                swalServices.Error(response.message);
            }
            setIsRejected(false);
        });
    };

    if (route !== "") {
        return <Navigate to={route} />;
    }

    return (
        <div>
            <div className="main-body-section">
                <div className="bg-white">
                    <div className=" heading-part px-7 py-4 border-b">
                        <h4 className="small-title font-bold theme-color">Booking Details</h4>
                    </div>

                    <div className="mb-2 overflow-x-auto  px-7 py-4">
                        <table className="partner-tbl w-full mx-auto my-5 fixed_header border-2">
                            <thead>
                                <tr className="text-base font-bold flex">
                                    <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                        <div className="font-bold tble-th-txt text-left">Class Name</div>
                                    </th>
                                    <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                        <div className="font-bold tble-th-txt text-center ">Class Date</div>
                                    </th>
                                    <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                        <div className="font-bold tble-th-txt text-center">Time</div>
                                    </th>
                                    <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                        <div className="font-bold tble-th-txt text-center">Session</div>
                                    </th>
                                    <th className="px-2 first:pl-5 last:pr-5 tbl-th 2xl:whitespace-nowrap lg:whitespace-normal text-white w-[20%]">
                                        <div className="font-bold tble-th-txt text-center">Location</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="scrollit text-sm custom-tbody ">
                                <tr className="custom-tbl-td flex">
                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                        {bookingCancellationDetails?.className}
                                    </td>
                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                        <div className="dollar-sign-icon inline-block">
                                            {moment(bookingCancellationDetails?.classDate).format("DD MMM YYYY")}
                                        </div>
                                    </td>
                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                        <div className="dollar-sign-icon inline-block">
                                            {bookingCancellationDetails?.eventStartTime} -{" "}
                                            {bookingCancellationDetails?.eventEndTime}
                                        </div>
                                    </td>
                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                        {bookingCancellationDetails?.availableSessions}
                                    </td>
                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                        {bookingCancellationDetails?.location
                                            ? bookingCancellationDetails?.location
                                            : "N.A"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className=" heading-part px-7 py-4 ">
                        <h4 className="small-title font-bold theme-color">Cancellation Details</h4>
                       

                    </div>
                    <div className="px-7 py-4">
                        <div className="grid grid-cols-12 gap-6 w-full">
                            <div className="xl:col-span-6 lg:col-span-6 col-span-12 py-2  border">
                                <div className="pb-2 cancelation-detail-sec">
                                    <div className="left-title">
                                        <h2 className="text-xl theme-color ml-4 py-2 ">Reason</h2>
                                    </div>
                                    <div className="desc-sec">
                                        <h2 className="text-xl theme-color ">
                                            {bookingCancellationDetails?.reason}
                                        </h2>
                                        {bookingCancellationDetails?.medicalCertificate &&
                                            <div className="right-link text-xl theme-color " onClick={() =>
                                                window.open(
                                                    APIURL +
                                                    "Common/GetPDF?type=MedicalCertificate&&fileName=" +
                                                    bookingCancellationDetails?.medicalCertificate,
                                                    "_blank"
                                                )
                                            }>
                                                <img src="/file-icon.png" title={bookingCancellationDetails?.medicalCertificateName}></img>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="pb-2 cancelation-detail-sec">
                                    <div className="left-title">
                                        <h2 className="text-xl theme-color ml-4">Refund</h2>
                                    </div>
                                    <div className="desc-sec">
                                        <h2 className="text-xl theme-color ">
                                            {/* {bookingCancellationDetails?.refundAmount && bookingCancellationDetails?.refundAmount} */}
                                            SGD {Number(bookingCancellationDetails?.refundAmount ?? 0).toFixed(2)}
                                        </h2>
                                        <div className="right-link text-xl theme-color "
                                            onClick={() =>
                                                window.open(
                                                    APIURL +
                                                    "Common/GetPDF?type=MedicalCertificate&&fileName=" +
                                                    bookingCancellationDetails?.creditNoteFilePath,
                                                    "_blank"
                                                )
                                            }
                                        >
                                            <img src="/file-icon.png" title="CreditNote.pdf"></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" heading-part px-7 py-4 ">
                        <h4 className="small-title font-bold theme-color ">Booking Details</h4>
                    </div>
                    <div className="px-7 py-4">
                        <div className="grid grid-cols-12 gap-6 w-full cancellation-booking-detail-card">
                            <div className="xl:col-span-6 lg:col-span-6 col-span-12  border booking-card">
                                <div className="flex items-center ">
                                    <h2 className="text-xl theme-color w-[40%] key-title">
                                        Booking Ref. No 
                                    </h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {bookingCancellationDetails?.bookingReferenceNo}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">Status</h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {bookingCancellationDetails?.bookingStatus}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">Attendee</h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {bookingCancellationDetails?.attendeeName}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">Contact No</h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {bookingCancellationDetails?.contactNo}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">Booking Date</h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {moment(bookingCancellationDetails?.bookingDate).format("DD MMM YYYY")}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">Payment Type</h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {bookingCancellationDetails?.paymentVia}
                                    </h2>
                                </div>
                            </div>

                            <div className="xl:col-span-6 lg:col-span-6 col-span-12  border booking-card">
                                <div className="flex items-center ">
                                    <h2 className="text-xl theme-color w-[40%] key-title">Promo Code</h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {bookingCancellationDetails?.promoCode
                                            ? bookingCancellationDetails?.promoCode
                                            : "N.A"}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">
                                        Discount Price
                                    </h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {bookingCancellationDetails?.discountPrice}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">
                                       Price before GST
                                    </h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        SGD {Number(bookingCancellationDetails?.totalPrice ?? 0).toFixed(2)}
                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">
                                        GST
                                    </h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {/* SD {bookingCancellationDetails?.gstPrice.toFixed(2)} */}
                                        SGD {Number(bookingCancellationDetails?.gstPrice ?? 0).toFixed(2)}

                                    </h2>
                                </div>
                                <div className="flex items-center">
                                    <h2 className="text-xl theme-color w-[40%] key-title">Price with GST</h2>
                                    <h2 className="text-xl theme-color w-[60%] value-title">
                                        {/* SD {bookingCancellationDetails?.totalPrice?.toFixed(2)} */}
                                        SGD {Number(bookingCancellationDetails?.totalPrice ?? 0).toFixed(2)}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-6">
                    <div className="2xl:col-span-12 lg:col-span-12 col-span-12">
                        <div className="flex flex-wrap justify-between space-x-10 mt-12">
                            <div>
                                <button
                                    className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white"
                                    onClick={() => Navigate("/booking/BookingCancellation")}
                                >
                                    Back
                                </button>
                            </div>
                            {bookingCancellationDetails?.bookingStatusId != null &&
                                bookingCancellationDetails?.bookingCancalltionStatusId != null &&
                                ![3, 9].includes(
                                bookingCancellationDetails?.bookingStatusId === 3
                                    ? 3
                                    : bookingCancellationDetails?.bookingCancalltionStatusId
                                ) && (<div>
                                <button
                                    className="w-32 px-7  mr-12 py-2 btn-sm btn-theme-dark text-lg text-white"
                                    onClick={approveBookingRequestForCancellation}
                                    disabled={IsRejected}
                                >
                                    Accept
                                </button>

                             {IsRejected ?  <ButtonLoader className="buttonload group relative rounded-md btn btn-red text-xl text-white focus:outline-none"/>:   <button
                                    className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white"
                                    onClick={rejectBookingRequestForCancellation}
                                >
                                    Reject 
                                </button>}
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            <AcceptBookingCancellation modalOpen={modalOpen} setModalOpen={setModalOpen} bookingCancellationDetails={bookingCancellationDetails} getBookingCancellationDetailsById={getBookingCancellationDetailsById} />
        </div>
    );
};

export default LNewBookingCancellationDetail;
